import { render, staticRenderFns } from "./PanelSidebar.vue?vue&type=template&id=22fde0fb&"
import script from "./PanelSidebar.vue?vue&type=script&lang=js&"
export * from "./PanelSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fde0fb')) {
      api.createRecord('22fde0fb', component.options)
    } else {
      api.reload('22fde0fb', component.options)
    }
    module.hot.accept("./PanelSidebar.vue?vue&type=template&id=22fde0fb&", function () {
      api.rerender('22fde0fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/panel/PanelSidebar.vue"
export default component.exports